import type React from "react";
import { SHOP_INFO } from "../config";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 text-gray-600 py-12 md:py-16 mt-0 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-10">
          <a
            href="http://temomio.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 group hover:opacity-80 transition-opacity"
          >
            <div className="bg-white p-2 rounded-xl shadow-sm border border-gray-100 group-hover:shadow-md transition-shadow">
              <img
                src={`${SHOP_INFO.basePath}/logo.webp`}
                alt="手もみ王ロゴ"
                className="h-10 w-10 object-contain"
                loading="lazy"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-xs text-gray-400 font-bold tracking-wider mb-0.5 uppercase">
                Relaxation Salon
              </span>
              <h2 className="text-2xl font-black tracking-tight text-gray-800">
                手もみ王
              </h2>
            </div>
          </a>

          <div className="flex gap-6">
            {/* Social links or other footer links could go here */}
          </div>
        </div>

        <div className="border-t border-gray-200 w-full mb-8"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400 font-bold tracking-wide uppercase">
          <p>
            &copy; {new Date().getFullYear()} {SHOP_INFO.name} All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
